<template>
  <div class="show_all_content_wrapper">
    <main>
      <div class="table_title_wrapper">
        <div class="title_text_wrapper">
          <h5>{{ $t("PLACEHOLDERS.Overall_statistics") }}</h5>
        </div>
        <div class="print_btn_wrapper">
          <v-btn class="print_stats_btn" small @click="printStatistics">
            <i class="fas fa-print me-2"></i>
            {{ $t("BUTTONS.print") }}
          </v-btn>
        </div>
      </div>

      <div ref="statsPrintArea" class="statics mt-4">
        <div class="row">
          <div
            class="col-lg-6 col-md-6 col-12"
            v-for="(item, index) in statCards"
            :key="`stat_${index}`"
          >
            <router-link class="box" :to="item.route">
              <div class="icon">
                <i :class="item.icon"></i>
              </div>

              <div class="info_box">
                <span>{{ item.label }}</span>
                <p class="number_box">{{ item.value }}</p>
              </div>
            </router-link>
          </div>
        </div>

        <!-- <div class="row mt-2">
          <div class="col-lg-6 col-12">
            <div class="chart_card status_chart_card">
              <h4 class="chart_title m-0">{{ chartTitle }}</h4>

              <apexchart
                type="donut"
                width="100%"
                height="330"
                :options="donutChartOptions"
                :series="donutChartSeries"
              ></apexchart>
            </div>
          </div>

          <div class="col-lg-6 col-12">
            <div class="latest_orders_wrapper">
              <div class="latest_orders_header">
                <h4>{{ latestOrdersTitle }}</h4>
                <router-link class="show_all_btn" to="/donations/all">
                  {{ $t("BUTTONS.show_all") }}
                </router-link>
              </div>

              <div class="table-responsive">
                <table class="table table-striped latest_orders_table mb-0">
                  <thead>
                    <tr>
                      <th>{{ $t("PLACEHOLDERS.orderNum") }}</th>
                      <th>{{ $t("PLACEHOLDERS.clientName") }}</th>
                      <th>{{ $t("PLACEHOLDERS.orderStatus") }}</th>
            </div>
                    </tr>
                  </thead>

                  <tbody>
                    <tr v-for="order in latestOrders" :key="order.id">
                      <td>
                        <router-link :to="`/donations/show/${order.id}`"
                          >#{{ order.id }}</router-link
                        >
                      </td>
                      <td>{{ order.user.full_name }}</td>
                      <td>
                        <v-chip small>
                          {{ getOrderStatus(order) }}
                        </v-chip>
                      </td>
                      <td>{{ order.created_at || "-" }}</td>
                    </tr>

                    <tr v-if="!latestOrders.length && !loadingOrders">
                      <td colspan="4" class="text-center">
                        {{ $t("TABLES.noData") }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </main>
  </div>
</template>

<script>
export default {
  name: "HomePage",

  computed: {
    statCards() {
      return [
        {
          label: this.$t("PLACEHOLDERS.total_patients"),
          value: this.safeNumber(this.stats.total_patients),
          icon: "fas fa-user-injured",
          route: "/patients/all",
        },
        {
          label: this.$t("PLACEHOLDERS.total_branches"),
          value: this.safeNumber(this.stats.total_branches),
          icon: "fas fa-code-branch",
          route: "/branches/all",
        },
        {
          label: this.$t("PLACEHOLDERS.total_reservation_today"),
          value: this.safeNumber(this.stats.total_reservation_today),
          icon: "fas fa-calendar-check",
          route: "/reservations/all",
        },
        {
          label: this.$t("PLACEHOLDERS.total_contact_us_not_reply"),
          value: this.safeNumber(this.stats.total_contact_us_not_reply),
          icon: "fas fa-envelope-open-text",
          route: "/contact-messages/all",
        },
      ];
    },

    chartTitle() {
      return this.$i18n.locale === "ar"
        ? "التوزيع النسبي لحالات الطلبات"
        : "Orders Status Distribution";
    },

    latestOrdersTitle() {
      return this.$i18n.locale === "ar" ? "أحدث الطلبات" : "Latest Orders";
    },

    statusChartLabels() {
      return [
        this.$t("PLACEHOLDERS.new"),
        this.$t("PLACEHOLDERS.assigned_to_supervisor"),
        this.$t("PLACEHOLDERS.in_progress"),
        this.$t("PLACEHOLDERS.on_the_way"),
        this.$t("STATUS.completed"),
      ];
    },

    donutChartSeries() {
      return [
        this.safeNumber(this.stats.new),
        this.safeNumber(this.stats.assigned_to_supervisor),
        this.safeNumber(this.stats.in_progress),
        this.safeNumber(this.stats.on_the_way),
        this.safeNumber(this.stats.completed),
      ];
    },

    donutChartOptions() {
      return {
        dataLabels: {
          enabled: false,
        },
        plotOptions: {
          pie: {
            donut: {
              size: "70%",
            },
          },
        },
        labels: this.statusChartLabels,
        legend: {
          position: "bottom",
        },
        colors: ["#f39c12", "#1976d2", "#26a69a", "#7e57c2", "#43a047"],
      };
    },
  },

  data() {
    return {
      loadingStats: false,
      loadingOrders: false,
      refreshIntervalId: null,
      stats: {
        total_patients: 0,
        total_reservation_today: 0,
        total_branches: 0,
        total_contact_us_not_reply: 0,
      },
      latestOrders: [],
    };
  },

  methods: {
    safeNumber(value) {
      const normalized = Number(value);
      return Number.isFinite(normalized) ? normalized : 0;
    },

    getOrderStatus(order) {
      return order?._status || this.$t(order?.status) || "-";
    },

    getOrderTypeLabel(order) {
      const type = order?.type || order?.order_type || order?.donation_type;
      if (type === "product") {
        return this.$t("product");
      }
      if (type === "package") {
        return this.$t("package");
      }

      if (Array.isArray(order?.items) && order.items.length) {
        const firstType = order.items[0]?.type;
        if (firstType === "product") {
          return this.$t("product");
        }
        if (firstType === "package") {
          return this.$t("package");
        }
      }

      return "-";
    },

    async getStatistics() {
      this.loadingStats = true;
      try {
        const res = await this.$axios({
          method: "GET",
          url: "statistics",
        });

        const payload = res?.data?.data?.data || res?.data?.data || {};
        this.stats = {
          total_patients: this.safeNumber(
            payload.total_patients ?? payload.clients
          ),
          total_reservation_today: this.safeNumber(
            payload.total_reservation_today ?? payload.total_reservations_today
          ),
          total_branches: this.safeNumber(payload.total_branches),
          total_contact_us_not_reply: this.safeNumber(
            payload.total_contact_us_not_reply ??
              payload.total_contact_us_not_replay
          ),
        };
      } catch (error) {
        this.stats = {
          total_patients: 0,
          total_reservation_today: 0,
          total_branches: 0,
          total_contact_us_not_reply: 0,
        };
      } finally {
        this.loadingStats = false;
      }
    },

    async getLatestOrders() {
      this.loadingOrders = true;
      try {
        const res = await this.$axios({
          method: "GET",
          url: "donations",
          params: {
            page: 1,
            limit: 3,
          },
        });

        const rows = res?.data?.data?.data || res?.data?.data || [];
        this.latestOrders = Array.isArray(rows) ? rows.slice(0, 3) : [];
      } catch (error) {
        this.latestOrders = [];
      } finally {
        this.loadingOrders = false;
      }
    },

    async loadDashboardData() {
      await Promise.all([this.getStatistics(), this.getLatestOrders()]);
    },

    startAutoRefresh() {
      this.refreshIntervalId = setInterval(() => {
        this.loadDashboardData();
      }, 30000);
    },

    stopAutoRefresh() {
      if (this.refreshIntervalId) {
        clearInterval(this.refreshIntervalId);
        this.refreshIntervalId = null;
      }
    },

    printStatistics() {
      const printableNode = this.$refs.statsPrintArea;
      if (!printableNode) return;

      const printWindow = window.open("", "_blank", "width=1000,height=700");
      if (!printWindow) return;

      const isArabic = this.$i18n.locale === "ar";
      const title = this.$t("PLACEHOLDERS.Overall_statistics");
      const baseOrigin = window.location.origin;

      printWindow.document.write(`
        <html>
          <head>
            <title>${title}</title>
            <base href="${baseOrigin}/" />
            <link rel="stylesheet" href="${baseOrigin}/all.css" />
            <style>
              body {
                font-family: Tahoma, Arial, sans-serif;
                padding: 20px;
                direction: ${isArabic ? "rtl" : "ltr"};
              }
              h2 {
                color: #233076;
                margin-bottom: 18px;
              }
              .row {
                display: flex;
                flex-wrap: wrap;
                margin: 0 -10px;
              }
              .col-lg-6 {
                width: 50%;
                padding: 0 10px;
                box-sizing: border-box;
                margin-bottom: 12px;
              }
              .box {
                background: #233076;
                border-radius: 6px;
                padding: 18px;
                color: #fff;
                display: flex;
                justify-content: space-between;
                align-items: center;
                text-decoration: none;
              }
              .icon {
                width: 48px;
                min-width: 48px;
                height: 48px;
                border-radius: 50%;
                background: #fff;
                color: #000;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 20px;
              }
              .icon i,
              .icon .fa,
              .icon .fas,
              .icon .far,
              .icon .fal,
              .icon .fab {
                font-family: "Font Awesome 5 Pro", "Font Awesome 5 Free", "Font Awesome 5 Brands" !important;
                font-weight: 900;
              }
              .info_box {
                display: flex;
                flex-direction: column;
                ${
                  isArabic
                    ? "align-items: flex-end;"
                    : "align-items: flex-start;"
                }
              }
              .info_box span {
                font-size: 18px;
              }
              .number_box {
                font-size: 30px;
                font-weight: 700;
                margin: 0;
                line-height: 1.1;
              }
              @media print {
                .col-lg-6 {
                  width: 50% !important;
                }
              }
            </style>
          </head>
          <body>
            <h2>${title}</h2>
            ${printableNode.innerHTML}
          </body>
        </html>
      `);

      printWindow.document.close();
      printWindow.onload = () => {
        printWindow.focus();
        setTimeout(() => {
          printWindow.print();
          printWindow.close();
        }, 350);
      };
    },
  },

  mounted() {
    this.getStatistics();
  },

  beforeDestroy() {
    this.stopAutoRefresh();
  },
};
</script>

<style lang="scss" scoped>
.show_all_content_wrapper {
  .table_title_wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
  }

  .print_stats_btn {
    color: #233076;
    border: 1px solid #233076;
    background: #fff;
    text-transform: none;
    font-weight: 600;
  }

  .statics {
    .box {
      background: #233076;
      padding: 25px;
      margin-bottom: 10px;
      border-radius: 5px;
      overflow: hidden;
      display: flex;
      justify-content: space-between;
      text-decoration: none;

      transition: all 0.5s;

      &:hover {
        background: #fff;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

        .icon {
          i {
            color: #233076;
          }
        }
        .info_box {
          span,
          p.number_box {
            color: #000;
          }
        }
      }

      .icon {
        height: 60px;
        min-width: 60px;
        width: 60px;
        border-radius: 60px;
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: center;

        i {
          font-size: 25px;
          color: #000;
        }
      }

      .info_box {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-end;

        span {
          font-size: 19px;
          color: #fff;
        }

        p.number_box {
          font-size: 30px;
          color: #fff;
          font-weight: bold;
        }
      }
    }
  }
}
.show_all_content_wrapper .statics .box .info_box {
  align-items: flex-start !important;
  width: 100% !important;
  padding-inline-start: 5% !important;
}

.status_chart_card,
.latest_orders_wrapper {
  min-height: 420px;
}

.latest_orders_wrapper {
  background: #ffffff;
  border-radius: 8px;
  padding: 18px;
  border: 1px solid #eef0f3;
}

.latest_orders_header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;

  h4 {
    margin: 0;
    color: #233076;
    font-size: 18px;
  }
}

.show_all_btn {
  color: #233076;
  text-decoration: none;
  font-weight: 600;
}

.latest_orders_table {
  th {
    color: #233076;
    white-space: nowrap;
  }

  td {
    vertical-align: middle;
  }
}
</style>
